/** Formato es-AR de cantidades de la fase 1 (conteos, porcentajes, segundos). Puro. */

const intFmt = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 });
const pctFmt = new Intl.NumberFormat('es-AR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const secFmt = new Intl.NumberFormat('es-AR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/** Número finito o `null` (nada de `NaN` ni strings raros). */
export function metaNum(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/** `31000` → «31.000». Sin dato → «—». */
export function formatMetaCount(value) {
  const n = metaNum(value);
  return n == null ? '—' : intFmt.format(n);
}

/** `55.6` → «55,6 %». Sin dato → «—». */
export function formatMetaPct(value) {
  const n = metaNum(value);
  return n == null ? '—' : `${pctFmt.format(n)} %`;
}

/** `6.1` → «6,1 s». Sin dato → «—». */
export function formatMetaSeconds(value) {
  const n = metaNum(value);
  return n == null ? '—' : `${secFmt.format(n)} s`;
}

/** `1 contacto` / `14 contactos`. */
export const metaPlural = (n, one, many) => `${formatMetaCount(n)} ${Number(n) === 1 ? one : many}`;

/**
 * Marca que la API pone al final del nombre de lo creado desde Terrio (F2b, « [TR0000ABCD]»): sirve
 * para encontrarlo en Meta, pero no se muestra. Formato fijo: espacio + `[TR` + 8 hex mayúsculas + `]`.
 */
export const META_TERRIO_MARK_RE = /\s*\[TR[0-9A-F]{8}\]$/;

/** «Dúplex Chacras I [TR0000ABCD]» → «Dúplex Chacras I». Lo que no es texto vuelve tal cual. */
export function stripMetaTerrioMark(name) {
  if (typeof name !== 'string') return name;
  return name.replace(META_TERRIO_MARK_RE, '');
}

/**
 * ¿El nombre trae la marca de Terrio? Es lo que hoy distingue una campaña creada desde Terrio (F2b) de
 * una vinculada: si el dueño la renombra en Meta y borra la marca, deja de reconocerse.
 */
export function hasMetaTerrioMark(name) {
  return typeof name === 'string' && META_TERRIO_MARK_RE.test(name);
}
